import { FormControl, Box } from '@mui/material';
import styled from 'styled-components';

export const CustomFormControl = styled(FormControl)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const CustomLabel = styled.span`
  font-size: 14px;
`;

export const CustomHorizontalSpacer = styled(Box)`
  width: 10px;
`;
